import { SitesModel } from "@/Common/Models/Sites/SitesModel";

class SiteHelper {
    public static GetContexts(): string[] {
        var contextes = cacheStore.SiteCache
            .filter((x: SitesModel) => x.Model.LabContext != null && x.Model.LabContext != "")
            .map(y => y.Model.LabContext);
        if (contextes != null && contextes.length > 0) {
            return contextes;
        }
        return [];
    }
}

export { SiteHelper };
